import "../servise.scss"
import ServiseFooter from "./servise_footer";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
const ServiseMoto = () => {
   return (
    <div className="servise-page">
      <>
          <Helmet>
              <title>Pro Moto - serwis motocykli</title>
              <meta
              name="description"
              content="W PRO MOTO przywracamy motocykle do perfekcyjnej formy, 
              skupiając się wyłącznie na pracach mechanicznych. Możesz liczyć na 
              wyspecjalizowaną obsługę silników, zawieszenia, hamulców układu paliwowego i napędu."
              />
              <link rel="canonical" href="https://promotoserwis.pl/serwis-motocykli" />
          </Helmet>
      </>
      <section className="servise-hero">
        <div className="servise-hero__content">
          <motion.h1
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}>SERWIS MOTOCYKLI</motion.h1>
          <motion.h2
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
              W PRO MOTO przywracamy motocykle do perfekcyjnej formy, 
              skupiając się wyłącznie na pracach mechanicznych. Możesz liczyć na 
              wyspecjalizowaną obsługę silników, zawieszenia, hamulców układu paliwowego i napędu.
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
            <strong>Przed wstawieniem na serwis prosimy o umycie pojazdu.</strong>
          </motion.p>

          <button
            className="servise-scroll-btn"
            onClick={() =>
              document.querySelector(".servise-extra").scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="arrow"></span>
          </button>
        </div>
      </section>

      <section className="servise-extra">
        <div className="servise-extra__container">

          <div className="servise-block">
            <h3 className="servise-block_title">Zakres usług</h3>
          </div>

          <div className="servise-block">
            <h2>Silnik, układ napędowy</h2>
            <ul>
              <li>Wymiana oleju, filtrów i świec zapłonowych</li>
              <li>Regulacja luzów zaworowych, wymiana łańcucha rozrządu</li>
              <li>Kontrola kompresji, wymiana tarcz sprzęgłowych</li>
              <li>Serwis gaźników: czyszczenie, synchronizacja, regulacja</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Zawieszenie, koła</h2>
            <ul>
              <li>Uszczelniacze i olej w lagach, amortyzatory przednie</li>
              <li>Wymiana łożysk kół i główki ramy</li>
              <li>Montaż opon, wyważanie, serwis łożysk wahacza</li>
            </ul>
          </div>

          <div className="servise-block">
            <h2>Układ hamulcowy</h2>
            <ul>
              <li>Wymiana klocków i tarczy hamulcowych</li>
              <li>Płukanie i wymiana płynu hamulcowego</li>
              <li>Serwis zacisków oraz pomp hamulcowych / sprzęgłowych</li>
            </ul>
          </div>
        
          <div className="servise-block">
            <h2>Napęd łańcuchowy, Kardana</h2>
            <ul>
              <li>Czyszczenie, smarowanie i regulacja naciągu łańcucha</li>
              <li>Wymiana kompletnych zestawów napędowych (z demontażem wahacza lub bez)</li>
              <li>Serwis przekładni głównej w napędzie Kardana</li>
            </ul>
          </div>
          <div className="servise-block">
            <h2>Układ chłodzenia, wydech</h2>
            <ul>
              <li>Wymiana płynu chłodniczego, kontrola szczelności</li>
              <li>Montaż i demontaż układu wydechowego oraz tłumików</li>
            </ul>
          </div>
          <ServiseFooter/>

        </div>
      </section>
    </div>
  );
};


export default ServiseMoto;